define('Components/PageHeaderWidget/js/models/PageHeaderV2Model',['jquery',
        'app',
        'Components/PageHeaderWidget/js/models/PageHeaderWidgetInstanceModel',
        'UrlFactory'
    ],
    function ($, app, PageHeaderWidgetInstanceModel, UrlFactory) {

        function isDesktop(){
            return app.isDesktop();
        }

        function suffixMobile(){
            return isDesktop()?'':'_mobile';
        }

        return PageHeaderWidgetInstanceModel.extend({
            name: 'PageHeaderV2Model',
            hasOverlayImage: function(){
                  var attributeName = 'overlay_image'+suffixMobile(),
                      attr = this.p(attributeName);
                  return parseInt(attr) > 0 ? attr : false;
            },
            getOverlayImage: function () {
                // default picture settings
                var suffix = 'noscale',
                    format = 'PNG';

                var model = this,
                    id_picture = model.hasOverlayImage(),
                    baseline = model.get('baseline'),
                    url;
                url = app.getPictureUrl(id_picture, 'Widget', suffix, format, baseline);

                return url || false;
            },
            getVideo: function(){
                var attrName = 'videourl'+suffixMobile(),
                    attrVal = this.p(attrName);
                if(attrVal !== ''){
                    return UrlFactory.getUrlVideo(attrVal, '1080p', 'standard');
                }
                return false;
            },
            getHorizontalAlign: function(){
                return this.p('horizontal_align'+suffixMobile()) || 'center';
            },
            getVerticalAlign: function(){
                return this.p('vertical_align'+suffixMobile()) || 'center';
            },
            getBgColor: function(){
               return this.p('background_color') || 'transparent';
            },
            getOverlayImageClasses: function(){
                var classes = 'home-header-v2-widget__overlay-image overlay--'+(isDesktop()?'desktop':'mobile');
                if(!isDesktop()){
                    classes += ' home-header-v2-widget__overlay-image--'+this.p('overlay_image_mobile_resize');
                }
                return classes;
            },
            getOverlayLinkClasses: function(){
                var classes = 'cta home-header-v2-widget__overlay home-header-v2-widget__overlay--'+this.getHorizontalAlign();
                    classes += ' home-header-v2-widget__overlay--'+this.p('overlay_image_mobile_resize');
                return classes;
            }
        })
    });
